<template>
  <div class="dropdown locale_switcher">
    <PopoverRoot v-model:open="isOpen">
      <PopoverTrigger class="dropdown-toggle drop_down">
        <Flag :country="countries[$i18n.locale]" />
      </PopoverTrigger>
      <PopoverContent
        as="ul"
        class="locale_switcher_menu"
        side="bottom"
        align="center"
        :side-offset="2"
      >
        <li
          v-for="local of locales.filter(el => el !== $i18n.locale)"
          :key="local"
          @click="selectLocal(local)"
        >
          <Flag :country="countries[local]" />
        </li>
      </PopoverContent>
    </PopoverRoot>
  </div>
</template>

<script>
import { PopoverRoot, PopoverTrigger, PopoverContent } from 'reka-ui'
import { storage } from '@/helpers/base/localstorage'
import Flag from '@/components/shared/Flag.vue'
import { setCookie } from '@/helpers/base/cookie'

export default {
  data() {
    return {
      isOpen: false,
      countries: {
        en: 'United Kingdom',
        ru: 'Russian Federation',
      },
    }
  },
  components: { PopoverRoot, PopoverTrigger, PopoverContent, Flag },
  computed: {
    locales() {
      return process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',')
    },
  },
  mounted() {
    // setCookie
    this.changeLocal(this.$i18n.locale)
  },
  methods: {
    changeLocal(locale) {
      this.$i18n.locale = locale
      setCookie('i18n_user_locale', locale, 360)
    },
    selectLocal(locale) {
      this.changeLocal(locale)
      this.isOpen = false
    },
  },
}
</script>

<style scoped>
span {
  color: white;
}
.dropdown {
  text-align: center;
}
button {
  background: none;
  text-align: center;
}
button :deep(.flag) {
  margin: 0;
  width: 20px;
  height: 20px;
}
button::after {
  display: none;
}
</style>

<!-- меню рендерится в обёртке поппера Reka — стили глобальные -->
<style>
ul.locale_switcher_menu {
  width: 42px;
  min-width: auto;
  margin: 0;
  padding: 0.5rem 0;
  list-style: none;
  text-align: center;
  background: var(--bg-surface);
  border: 1px solid var(--border-color);
  border-radius: 0.375rem;
  z-index: 1000;
}
ul.locale_switcher_menu li {
  cursor: pointer;
}
ul.locale_switcher_menu li:hover {
  background: var(--bg-hover);
  border-radius: 7px;
}
ul.locale_switcher_menu .flag {
  margin: 0;
  width: 20px;
  height: 20px;
}
</style>
